import React, { Component } from "react";
import { Checkbox, Divider, Statistic, Typography } from "antd";
const { Text } = Typography;

const ITEM_GROUPS = [
  {
    id: "group_one",
    choices: [
      {
        id: "choice_one",
        title: "Veneuze lijn/pacemaker draad in situ",
        score: 1,
      },
    ],
  },
  {
    id: "group_two",
    choices: [
      {
        id: "choice_one",
        title: "Lokale pijn",
        score: 1,
      },
    ],
  },
  {
    id: "group_three",
    choices: [
      {
        id: "choice_one",
        title: "Unilateraal oedeem",
        score: 1,
      },
    ],
  },
  {
    id: "group_four",
    choices: [
      {
        id: "choice_one",
        title: "Andere diagnose tenminste even waarschijnlijk",
        score: -1,
      },
    ],
  },
];

export default class WellsScore extends Component {
  constructor(props) {
    super(props);

    const selectedChoices = {};
    for (const itemGroup of ITEM_GROUPS) {
      selectedChoices[itemGroup.id] = null;
    }

    this.state = {
      selectedChoices,
    };
  }

  render = () => {
    return (
      <>
        <div className="wrapper-interactive">
          {this.props.title ? (
            <>
              <h4>{this.props.title}</h4>
              <Divider />
            </>
          ) : null}
          {this._renderGroups()}
          <Statistic title="Score:" value={this._renderScore()} />
        </div>
      </>
    );
  };

  _renderGroups = () => {
    return ITEM_GROUPS.map((group) => {
      return (
        <div key={group.id}>
          <Text>{group.title}</Text>
          {group.choices.map((choice) => {
            return (
              <div style={{ padding: "12px 0" }}>
                <Checkbox
                  key={choice.id}
                  id={choice.title}
                  onChange={() => this._selectChoice(group, choice)}
                  checked={this.state.selectedChoices[group.id] === choice.id}
                  style={{ marginRight: "16px" }}
                />
                <label for={choice.title} style={{ color: "white" }}>
                  {choice.title}{" "}
                  {/* <Tag style={{ marginLeft: "15px" }}>{choice.score}</Tag> */}
                </label>
              </div>
            );
          })}
        </div>
      );
    });
  };

  _renderScore = () => {
    let score = 0;
    for (const group of ITEM_GROUPS) {
      for (const choice of group.choices) {
        if (choice.id === this.state.selectedChoices[group.id]) {
          score += choice.score;
        }
      }
    }

    return score;
  };

  _selectChoice = (group, choice) => {
    const groupId = group.id;
    const choiceId = choice.id;
    const selectedChoiceId = this.state.selectedChoices[groupId];
    const newChoiceId = selectedChoiceId === choiceId ? null : choiceId;

    this.setState({
      selectedChoices: Object.assign(this.state.selectedChoices, {
        [groupId]: newChoiceId,
      }),
    });
  };
}
